<div class="row">
  <div class="col-md-12">
<button (click)="toggle()" class="btn">Toggle Fade - Currently {{bindingVar}}</button>
</div>
</div>
<div class="row">
<div class="col-md-12">
<div [@someCoolAnimation]="bindingVar">Test By Clicking</div>
</div>
</div>
